import React, { FC } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import CategoryPage from '../../../../sales-kit/components/Category/pages/List';
import { ModulePermissionProps } from '../../../../../common/module/types';

const SystemConfig = {
  filterName: 'component.filterTitle.happy-share-material-category',
  blockName: 'component.formTitle.happy-share-material-category',
  blockType: 'happyShareMaterialCategory',
  moduleType: 'HappyShare',
  addSuccessText: 'global.submit.success',
};

const HappyShareCategoryPage: FC<RouteComponentProps & ModulePermissionProps> = (props) => {
  return <CategoryPage {...props} {...SystemConfig} />;
};

export default HappyShareCategoryPage;
